import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-home-banner',
    templateUrl: './home-banner.component.html',
    styleUrls: ['./home-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeBannerComponent implements OnInit {

  constructor() { }

  videoSource = '../assets/images/sat-final-video.mp4';

  ngOnInit(): void {
  }

}
